import { TyreSearchModel } from '../../models/tyre/tyreSearch';
import * as TyrePreviewModels from '../../models/tyre/tyrePreview';
import * as TyreParamiterModels from '../../models/tyre/tyreParameters';
import * as Models from '../../models/commonModels';
import * as TyreOfferApiModels from '../../models/tyre/tyreOfferApi';

export class GetSeasonsDictionary {
  static readonly type = '[Tyre] GetSeasonsDictionary';
  constructor() { }
}

export class GetBrandsDictionary {
  static readonly type = '[Tyre] Brand Dictionary';
  constructor() { }
}

export class GetTyreCarTypesDictionary {
  static readonly type = '[Tyre] TyreCarTypes Dictionary';
  constructor() { }
}

export class GetTyreSegmentsDictionary {
  static readonly type = '[Tyre] TyreSegments Dictionary';
  constructor() { }
}

export class GetTyreParameters {
  static readonly type = '[Tyre] TyreParameters';
  constructor() { }
}

export class GetTyreAvailableForSaleParameters {
  static readonly type = '[Tyre] AvailableForSaleParameters';
  constructor() { }
}

export class GetListSold {
  static readonly type = '[Tyre] List Sold';
  constructor(public search: TyreSearchModel) { }
}

export class GetListReseling {
  static readonly type = '[Tyre] List Reseling';
  constructor(public search: TyreSearchModel) { }
}

export class GetList {
  static readonly type = '[Tyre] List';
  constructor(public search: TyreSearchModel) { }
}

export class GetRimDictionary {
  static readonly type = '[Tyre] GetRimDictionary';
  constructor() { }
}


export class GetTyreWidthList {
  static readonly type = '[Tyre] GetTyreWidthsList';
  constructor() { }
}

export class GetTyreHeightList {
  static readonly type = '[Tyre] GetTyreHeightsList';
  constructor() { }
}

export class GetTyreDiameterList {
  static readonly type = '[Tyre] GetTyreDiametersList';
  constructor() { }
}

export class GetTyreConstructionTypeList {
  static readonly type = '[Tyre] GetTyreConstructionTypesList';
  constructor() { }
}

export class GetTyreSpeedIndexList {
  static readonly type = '[Tyre] GetTyreSpeedIndexesList';
  constructor() { }
}

export class GetTyreLoadIndexList {
  static readonly type = '[Tyre] GetTyreLoadIndexesList';
  constructor() { }
}

export class GetTyreReinforcementList {
  static readonly type = '[Tyre] GetTyreReinforcementsList';
  constructor() { }
}

export class GetBrandList {
  static readonly type = '[Tyre] GetBrandList';
  constructor() { }
}

export class GetProducerList {
  static readonly type = '[Tyre] GetProducerList';
  constructor() { }
}


export class GetTyreCarTypeList {
  static readonly type = '[Tyre] GetTyreCarTypeList';
  constructor() { }
}

export class SetTyreWidth {
  static readonly type = '[Tyre] SetTyreWidth';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreWidthModel>) { }
}

export class SetTyreHeight {
  static readonly type = '[Tyre] SetTyreHeight';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreHeightModel>) { }
}

export class SetTyreDiameter {
  static readonly type = '[Tyre] SetTyreDiameter';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreDiameterModel>) { }
}

export class SetTyreConstructionType {
  static readonly type = '[Tyre] SetTyreConstructionType';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreConstructionTypeModel>) { }
}

export class SetSpeedIndex {
  static readonly type = '[Tyre] SetSpeedIndex';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreSpeedIndexModel>) { }
}

export class SetLoadIndex {
  static readonly type = '[Tyre] SetLoadIndex';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreLoadIndexModel>) { }
}

export class SetReinforcement {
  static readonly type = '[Tyre] SetReinforcement';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreReinforcementModel>) { }
}

export class SetBrand {
  static readonly type = '[Tyre] SetBrand';
  constructor(public Value: Models.Request<TyreParamiterModels.BrandModel>) { }
}

export class SetProducer {
  static readonly type = '[Tyre] SetProducer';
  constructor(public Value: Models.Request<TyreParamiterModels.ProducerModel>) { }
}



export class DeleteTyreWidth {
  static readonly type = '[Tyre] DeleteTyreWidth';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreWidthModel>) { }
}

export class DeleteTyreHeight {
  static readonly type = '[Tyre] DeleteTyreHeight';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreHeightModel>) { }
}

export class DeleteTyreDiameter {
  static readonly type = '[Tyre] DeleteTyreDiameter';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreDiameterModel>) { }
}

export class DeleteTyreConstructionType {
  static readonly type = '[Tyre] DeleteTyreConstructionType';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreConstructionTypeModel>) { }
}

export class DeleteSpeedIndex {
  static readonly type = '[Tyre] DeleteSpeedIndex';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreSpeedIndexModel>) { }
}

export class DeleteLoadIndex {
  static readonly type = '[Tyre] DeleteLoadIndex';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreLoadIndexModel>) { }
}

export class DeleteReinforcement {
  static readonly type = '[Tyre] DeleteReinforcement';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreReinforcementModel>) { }
}




export class MergeTyreWidth {
  static readonly type = '[Tyre] MergeTyreWidth';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreWidthModel, TyreParamiterModels.TyreWidthModel>) { }
}

export class  MergeTyreHeight {
  static readonly type = '[Tyre] MergeTyreHeight';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreHeightModel, TyreParamiterModels.TyreHeightModel>) { }
}

export class  MergeTyreDiameter {
  static readonly type = '[Tyre] MergeTyreDiameter';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreDiameterModel, TyreParamiterModels.TyreDiameterModel>) { }
}

export class  MergeTyreConstructionType {
  static readonly type = '[Tyre] MergeTyreConstructionType';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreConstructionTypeModel, TyreParamiterModels.TyreConstructionTypeModel>) { }
}

export class  MergeSpeedIndex {
  static readonly type = '[Tyre] MergeSpeedIndex';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreSpeedIndexModel, TyreParamiterModels.TyreSpeedIndexModel>) { }
}

export class  MergeLoadIndex {
  static readonly type = '[Tyre] MergeLoadIndex';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreLoadIndexModel, TyreParamiterModels.TyreLoadIndexModel>) { }
}

export class  MergeReinforcement {
  static readonly type = '[Tyre] MergeReinforcement';
  constructor(public Value: Models.ContextRequest<TyreParamiterModels.TyreReinforcementModel, TyreParamiterModels.TyreReinforcementModel>) { }
}

export class GetTyreSupplierOffers {
  static readonly type = '[Tyre] TyreSupplierOffers';
  constructor(public Tyre: Models.Request<TyrePreviewModels.TyrePreviewModel>) { }
}

export class GetTyreSuppliers {
  static readonly type = '[Tyre] TyreSuppliers';
  constructor() { }
}

export class GetOffers {
  static readonly type = '[Tyre] GetOffers';
  constructor(public TyreSupplierOffer: Models.Request<TyreOfferApiModels.TyreSupplierOfferModel>) { }
}

export class DisposeSearch {
  static readonly type = '[Tyre] DisposeSearch';
  constructor() { }
}

export class SetSearch {
  static readonly type = '[Tyre] Set Search';
  constructor(public Search: TyreSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[Tyre] Reset Search';
  constructor() { }
}

export class ResetSearchOnPriceList {
  static readonly type = '[Tyre] Reset Search OnPriceList';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[Tyre] Set List Page';
  constructor(public Search: TyreSearchModel) { }
}



export class UpdateTyreDiameter {
  static readonly type = '[Tyre] UpdateTyreDiameter';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreDiameterModel>) { }
}

export class UpdateTyreCarType {
  static readonly type = '[Tyre] UpdateTyreCarType';
  constructor(public Value: Models.Request<TyreParamiterModels.TyreCarTypesModel>) { }
}
